import divolteInit from '@kryfe/divolte';
import { getFixedInfo, getDynamicInfo, getPageTypeFromUrl } from './divolteCommonInfo';
import { getUrlParams } from '../common-helper';
import { allBuryingPoint } from './globalBuryingPoint';

function isGldOrTestOrDevEvn() {
  return (
    /^(ci)?test/i.test(location.hostname) ||
    /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/.test(
      location.hostname,
    ) ||
    /^(dev|gld)/i.test(location.hostname)
  );
}
/*
  暂时只统计pageview事件, 屏蔽所有的点击事件统计
*/

const configs = [{ xpath: 'none' }];

const EXCLUDE_EVENT = ['error', 'click', 'performance-timing', 'resource-timing'];
const EVN_SCRIPT_MAP = {
  prod: {
    // url: 'https://divolte.keruyun.com/portal/divolte.js',
    url: 'https://divolte.keruyun.com/portal/divolte.js',
    validator: () => /^weixin/i.test(location.hostname),
  },
  test: {
    url: 'https://divolte.keruyun.com/portal/divolte.js',
    // url: 'https://citestbigdata-kry-divolte-private.shishike.com/portal/divolte.js',
    validator: () =>
      /^(ci)?test/i.test(location.hostname) ||
      /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/.test(
        location.hostname,
      ),
  },
  dev: {
    url: 'https://divolte.keruyun.com/portal/divolte.js',
    // url: 'https://citestbigdata-kry-divolte-private.shishike.com/portal/divolte.js',
    validator: () => /^(dev|gld)/i.test(location.hostname),
  },
};
const DEV_MODE = process.env.NODE_ENV === 'development';

const LOAD_STATUS = {
  willLoad: 'willLoad',
  loaded: 'loaded',
  loadError: 'loadError',
};

const buryingPointConfig = { enableDebug: DEV_MODE, excludeEvent: EXCLUDE_EVENT };

/**
 * 埋点工具
 */
class BuryingPoint {
  constructor() {
    this.isGldOrTestOrDevEvn = isGldOrTestOrDevEvn();
    this.dynamicDefaultParamFun = () => {};
    this.setDynamicDefaultParam(getDynamicInfo);
    this.setFixedDefaultParam(getFixedInfo());
    this.defaultParam = {};
    this._init();
  }
  _init() {
    this.loadStatus = LOAD_STATUS.willLoad;
    // 三个参数。
    // configs 配置信息。配置一些要监听的事件
    // defaultParam {
    //  enableDebug,是否开启调试模式
    //  excludeEvent,排除的监听的默认事件
    // }
    // scriptObj:根据环境加载divolte的script
    const info = this.getDefaultCommonInfo();
    const divoltePromise = divolteInit(configs, { ...info, ...buryingPointConfig }, EVN_SCRIPT_MAP);
    if (!divoltePromise || !divoltePromise.then) {
      console.error('kry-divolte必须高于1.2.3');
      this.loadStatus = LOAD_STATUS.loadError;
      return null;
    }
    this.divoltePromise = divoltePromise
      .then(data => {
        this.loadStatus = LOAD_STATUS.loaded;
      })
      .catch(ex => {
        this.loadStatus = LOAD_STATUS.loadError;
        console.error(ex);
      });
  }

  getToolObj() {
    if (this.loadStatus === LOAD_STATUS.willLoad) {
      return this.divoltePromise;
    } else if (this.loadStatus === LOAD_STATUS.loaded) {
      return Promise.resolve();
    }
    return Promise.reject(new Error('无法加载divolte对象'));
  }
  /**
   * 获取默认信息
   * 1、界面固定的信息
   * 2、界面可能发生变化的信息
   * 3、界面路径带的参数（为了和kry-divolte保持一致）
   */
  async getDefaultCommonInfo() {
    const fixedInfo = this.defaultFixedParam || {};
    const dynamicInfo = this.dynamicDefaultParamFun ? await this.dynamicDefaultParamFun() : {};
    const urlParams = getUrlParams() || {};
    return { ...urlParams, ...fixedInfo, ...dynamicInfo };
  }

  /**
   * 发送信息
   * @param {*} eventType
   * @param {*} param
   */
  send(eventType, param = {}) {
    return this.getToolObj()
      .then(data => {
        return this.getDefaultCommonInfo();
      })
      .then(info => {
        const sendInfo = { ...info, ...(param || {}), ...{ eventType } };
        if (this.isGldOrTestOrDevEvn) {
          console.group('触发埋点');
          console.log('事件', eventType);
          console.log('参数', sendInfo);
          console.groupEnd();
        }
        window.divolte.signal(eventType, sendInfo);
      })
      .catch(ex => {
        console.error(ex);
      });
  }
  /**
   * 设置默认传递的参数,固定（界面打开后不会再变化）
   * @param {*} info
   */
  setFixedDefaultParam(info) {
    this.defaultFixedParam = info;
  }
  setDynamicDefaultParam(fun) {
    this.dynamicDefaultParamFun = fun;
  }
}

const buryingPoint = new BuryingPoint();
allBuryingPoint(buryingPoint);

export default buryingPoint;

export { getPageTypeFromUrl };



// WEBPACK FOOTER //
// ./src/helper/divolte/register-divolte.js